import { AuthConstants } from './AuthConstants';
import HrbCasAuth from 'hrb-cas-auth-js';
import {ConfigConstants} from "../../configuration/ConfigConstants";

class Auth {

    constructor() {
        this.authProvider = null;
    }

    initProvider = (authConfig, clientIdUrlParam) => {
        this.initAuthProvider(authConfig);
    };

    initAuthProvider = (authConfig) => {
        let casDomain = authConfig[ConfigConstants.CAS_SERVICE_URL];
        let casClientId = authConfig[ConfigConstants.CAS_CLIENT_ID];
        let clientOrigin = window.location.origin;

        this.authProvider = new HrbCasAuth({
            namespace: AuthConstants.CAS_NAMESPACE,
            domain: casDomain,
            issuer: casDomain + '/oidc',
            clientId: casClientId,
            clientOrigin: clientOrigin,
            loginCallbackUrl: clientOrigin + '/callback',
            logoutCallbackUrl: clientOrigin + '/logout',
            otcLoginCallbackUrl: clientOrigin + '/otcCallback',
            otcClientId: 'OneTimeCode',
            responseType: 'id_token token',
            scope: 'openid profile profile_hrbAuth',
            useSessionStorage: false
        });
    };

    login = (language) => {
        if (this.authProvider) {
            this.authProvider.login(language);
        }
    };

    silentAuthentication = (callback) => {
        this.authProvider.authenticateSilently((result, err) => {
            if (result) {
                console.log(result);
            } else if (err) {
                const options = callback();
                console.log(err);
                this.authProvider.login(options.language);
            }
        });
    };

    otcAuthentication = (code, userName) => {
        return new Promise((resolve, reject) => {
            this.authProvider.authenticateOtc((result, err) => {
                if (result) {
                    console.log(result);
                    resolve(result);
                } else if (err) {
                    reject(err);
                }
            }, code, userName);
        });
    };

    passUserNameToCas = (userName) => {
        return new Promise((resolve, reject) => {
            this.authProvider.passUserName((result, err) => {
                if (result) {
                    console.log(result);
                    resolve(result);
                } else if (err) {
                    reject(err);
                }
            }, userName);
        });
    };

    handleAuthentication = (cb) => {
        return new Promise((resolve, reject) => {
            this.authProvider.handleAuthenticationResponse((authResult, err) => {
                if (authResult) {
                    resolve(authResult);
                } else if (err) {
                    reject(err);
                }
                resolve();
            });
        });
    };

    logout = () => {
        if (localStorage.getItem('myb_heap_app_id') && window.heap) {
            window.heap.resetIdentity()
        }
        this.authProvider.logout();
    };

    getAccessToken = () => {
        const accessToken = this.authProvider.getToken();
        if (!accessToken) {
            throw new Error('No access token found');
        }
        return accessToken;
    };

    getProfile = () => {
        if (this.authProvider && this.isAuthenticated()) {
            return this.authProvider.getUserProfile();
        }
        return {};
    };

    getTokenTimeToLive = () => {
        return this.authProvider.getTokenTimeToLive();
    }

    isAuthenticated = () => {
        if (this.authProvider) {
            return this.authProvider.isAuthenticated();
        }
        return false;
    };

    isRegularAuthentication = (authResult) => {
        return authResult.authType === this.authProvider.AUTH_TYPES.REGULAR;
    }
}

const auth = new Auth();
export default auth;